/* src/app/common/components/catalog/catalog-side-menus/catalog-side-menus.component.scss */
.active {
  --color: var(--ion-color-primary);
  font-weight: bold;
}
ion-badge {
  margin-left: 1rem;
}
/*# sourceMappingURL=catalog-side-menus.component.css.map */
